<template>
  <v-container v-if="DataPersonas !== null" grid-list-xl>
    <div class="vue-contentido">
      <v-divider></v-divider>

      <v-layout row wrap>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-card-title>Administración de Usuarios</v-card-title>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="searchpersonas"
              append-icon="search"
              label="Buscar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-card-text active-class="deep-purple accent-4 white--text">
            <v-flex xs12 sm12>
              <v-data-table
                :headers="headerpersonas"
                :items="DataPersonas"
                class="elevation-1"
                :no-data-text="gnodata"
                sort-text="prueba ordenar"
                :items-per-page="5"
                :search="searchpersonas"
              >
                <template v-slot:top>
                  <v-toolbar>
                    <v-toolbar-title>Lista de usuarios</v-toolbar-title>
                    <v-divider class="mx-4" inset vertical></v-divider>
                    <v-spacer></v-spacer>

                    <v-tooltip top>
                      <template
                        v-slot:activator="{ on }"
                        v-if="!puedesolovisualizar()"
                      >
                        <v-btn
                          icon
                          x-large
                          v-on="on"
                          @click="newpersona"
                          v-scroll-to="'#containera'"
                        >
                          <v-icon color="primary">add</v-icon>
                        </v-btn>
                      </template>
                      <span>Agregar</span>
                    </v-tooltip>
                  </v-toolbar>
                </template>
                <template v-slot:item.action="{ item }">
                  <v-tooltip top v-if="!puedesolovisualizar()">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        @click="gridedituser(item)"
                        v-scroll-to="'#containera'"
                        >edit</v-icon
                      >
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                  <v-tooltip top v-if="puedesolovisualizar()">
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        @click="gridedituser(item)"
                        v-scroll-to="'#containera'"
                        >mdi-eye</v-icon
                      >
                    </template>
                    <span>Ver</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        v-show="item.usuariobloqueado"
                        @click="desbloquearusuario(item)"
                        >mdi-lock-open</v-icon
                      >
                    </template>
                    <span>Desbloquear</span>
                  </v-tooltip>
                </template>
                <template v-slot:footer>
                  <div id="div1" style="width: 100%; align: right">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <download-excel
                          id="div2"
                          style="width: 100%; text-align: right"
                          v-show="DataPersonas.length > 0"
                          class="btn btn-default"
                          :data="DataPersonas"
                          :exportFields="exportable"
                          name="Usuarios.xls"
                          type="xls"
                          worksheet="Información"
                        >
                          <v-icon
                            color="secondary"
                            v-on="on"
                            large
                            elevation="2"
                            >mdi-file-download-outline</v-icon
                          >
                        </download-excel>
                      </template>
                      <span>Descargar</span>
                    </v-tooltip>
                  </div>
                </template>
              </v-data-table>
              <v-divider></v-divider>
            </v-flex>
          </v-card-text>
          <v-card v-show="framepersona" id="containera" ref="containera">
            <v-card-text>
              <v-flex row wrap>
                <v-flex sm6 xs12>
                  <v-text-field
                    v-model="Editedpersona.nombre"
                    label="Nombre funcionario: *"
                    v-validate="'required|alpha_spaces|max:100'"
                    :counter="100"
                    data-vv-name="nombrefuncionario"
                    :error-messages="errors.collect('nombrefuncionario')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm1 md1>
                  <v-checkbox
                    v-model="EditedUsuario.activo"
                    label="Activo"
                    :readonly="puedesolovisualizar()"
                  ></v-checkbox>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-select
                    v-if="!puedesolovisualizar()"
                    :items="groles"
                    v-model="SeletionRol"
                    item-text="nombre"
                    item-value="idrol"
                    label="Rol *"
                    multiple
                    v-validate="'required'"
                    data-vv-name="rolusuario"
                    :error-messages="errors.collect('rolusuario')"
                    @change="onchangeRol"
                  ></v-select>
                  <v-select
                    v-if="puedesolovisualizar()"
                    :items="groles"
                    v-model="SeletionRol"
                    item-text="nombre"
                    item-value="idrol"
                    label="Rol *"
                    multiple
                    v-validate="'required'"
                    data-vv-name="rolusuario"
                    :error-messages="errors.collect('rolusuario')"
                    @change="onchangeRol"
                    disabled
                  ></v-select>
                </v-flex>

                <v-flex sm7 xs12>
                  <v-select
                    v-if="!puedesolovisualizar()"
                    :items="gentidades"
                    v-model="Editedpersona.identidad"
                    item-text="nombre"
                    item-value="identidad"
                    label="Entidad *"
                    v-validate="'required'"
                    data-vv-name="entidad"
                    :error-messages="errors.collect('entidad')"
                  ></v-select>
                  <v-select
                    v-if="puedesolovisualizar()"
                    :items="gentidades"
                    v-model="Editedpersona.identidad"
                    item-text="nombre"
                    item-value="identidad"
                    label="Entidad *"
                    v-validate="'required'"
                    data-vv-name="entidad"
                    :error-messages="errors.collect('entidad')"
                    disabled
                  ></v-select>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-text-field
                    v-model="Editedpersona.cargo"
                    label="Cargo: *"
                    v-validate="'required|max:200'"
                    :counter="200"
                    data-vv-name="cargo"
                    :error-messages="errors.collect('cargo')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm7 xs12>
                  <v-text-field
                    v-model="Editedpersona.correo"
                    label="Usuario (correo electrónico): *"
                    v-validate="'required|email'"
                    data-vv-name="correoelectronico"
                    :error-messages="errors.collect('correoelectronico')"
                    :readonly="Editarpersona || puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-text-field
                    v-model="Editedpersona.correo"
                    label="Login usuario: *"
                    :readonly="true"
                  ></v-text-field>
                </v-flex>

                <v-flex sm3 xs12>
                  <v-select
                    v-if="!puedesolovisualizar()"
                    :items="gtipodocumentos"
                    v-model="Editedpersona.idtipodocumento"
                    item-text="nombre"
                    item-value="idtipodocumento"
                    label="Tipo Documento *"
                    v-validate="'required'"
                    data-vv-name="tipodocumento"
                    :error-messages="errors.collect('tipodocumento')"
                  ></v-select>
                  <v-select
                    v-if="puedesolovisualizar()"
                    :items="gtipodocumentos"
                    v-model="Editedpersona.idtipodocumento"
                    item-text="nombre"
                    item-value="idtipodocumento"
                    label="Tipo Documento *"
                    v-validate="'required'"
                    data-vv-name="tipodocumento"
                    :error-messages="errors.collect('tipodocumento')"
                    disabled
                  ></v-select>
                </v-flex>

                <v-flex sm4 xs12>
                  <v-text-field
                    v-model="Editedpersona.identificacion"
                    label="Nro de identificación: *"
                    v-validate="'required|max:50'"
                    :counter="50"
                    data-vv-name="identificacion"
                    :error-messages="errors.collect('identificacion')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-text-field
                    v-model="Editedpersona.dependencia"
                    label="Dependencia:"
                    v-validate="'max:200'"
                    :counter="200"
                    data-vv-name="dependencia"
                    :error-messages="errors.collect('dependencia')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm3 xs12>
                  <v-text-field
                    v-model="Editedpersona.telefono"
                    label="Teléfono:"
                    v-validate="'max:100'"
                    :counter="100"
                    data-vv-name="telefono"
                    :error-messages="errors.collect('telefono')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm4 xs12>
                  <v-text-field
                    v-model="Editedpersona.celular"
                    label="Celular:"
                    v-validate="'max:50'"
                    :counter="50"
                    data-vv-name="celular"
                    :error-messages="errors.collect('celular')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm7 xs12>
                  <v-text-field
                    v-model="Editedpersona.nombrejefe"
                    label="Nombre del jefe o superior: *"
                    v-validate="'required|max:100'"
                    :counter="100"
                    data-vv-name="nombrejefe"
                    :error-messages="errors.collect('nombrejefe')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-text-field
                    v-model="Editedpersona.correojefe"
                    label="Correo electrónico jefe o superior: *"
                    v-validate="'required|email|max:100'"
                    :counter="100"
                    data-vv-name="correojefe"
                    :error-messages="errors.collect('correojefe')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>
                <v-flex sm7 xs12>
                  <v-text-field
                    v-model="Editedpersona.nombreenlace"
                    label="Nombre del enlace: "
                    v-validate="'max:100'"
                    :counter="100"
                    data-vv-name="nombreenlace"
                    :error-messages="errors.collect('nombreenlace')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm5 xs12>
                  <v-text-field
                    v-model="Editedpersona.correoenlace"
                    label="Correo electrónico del enlace:"
                    v-validate="'email|max:100'"
                    :counter="100"
                    data-vv-name="correoenlace"
                    :error-messages="errors.collect('correoenlace')"
                    :readonly="puedesolovisualizar()"
                  ></v-text-field>
                </v-flex>

                <v-flex sm7 xs12>
                  <v-text-field
                    v-model="Editedpersona.telefonoenlace"
                    label="Teléfono del enlace:"
                    v-validate="'max:100'"
                    :counter="100"
                    data-vv-name="telefonoenlace"
                    :error-messages="errors.collect('telefonoenlace')"
                  ></v-text-field>
                </v-flex>

                <v-flex sm6 xs12 v-show="this.mostrarUsuarioPuntos">
                  <v-select
                    v-if="!puedesolovisualizar()"
                    :items="gpuntos"
                    v-model="SeleccionPunto"
                    item-text="nombre"
                    item-value="idpunto"
                    label="Punto *"
                    multiple
                    v-validate="this.mostrarUsuarioPuntos ? 'required' : ''"
                    data-vv-name="puntousuario"
                    :error-messages="errors.collect('puntousuario')"
                  ></v-select>
                  <v-select
                    v-if="puedesolovisualizar()"
                    :items="gpuntos"
                    v-model="SeleccionPunto"
                    item-text="nombre"
                    item-value="idpunto"
                    label="Punto *"
                    multiple
                    v-validate="this.mostrarUsuarioPuntos ? 'required' : ''"
                    data-vv-name="puntousuario"
                    :error-messages="errors.collect('puntousuario')"
                  ></v-select>
                </v-flex>
                <!-- <v-flex xs12 sm6 v-show="this.mostrarArchivoDelegado">
                  <v-file-input
                    accept=".pdf"
                    v-model="filearchivo"
                    show-size
                    label="Cargar archivo"
                    @change="onarchivodelegadochange"
                  ></v-file-input>
                </v-flex>
                <v-flex xs12 sm6 v-if="basearchivo">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-2" v-on="on" @click="descargarsoporte"
                        >Descargar archivo</v-btn
                      >{{ Editedpersona.nombreArchivo }}
                    </template>
                    <span>{{ Editedpersona.nombreArchivo }}</span>
                  </v-tooltip>
                  <v-icon small class="mr-2" @click="deletearchivodelegado()"
                    >clear</v-icon
                  >
                </v-flex> -->
                
                <v-flex v-show="this.mostrarArchivoDelegado">
                  <label>Soportes:</label>
                  <v-flex xs12 sm12>
                    <v-data-table
                      :headers="headerFieldsSoportes"
                      :items="soportes"
                      class="elevation-2"
                      :no-data-text="gnodata"
                      dense
                      :items-per-page="10"
                    >
                      <template v-slot:item.action="{ item }" >
                        <v-tooltip top v-if="!puedesolovisualizar()">
                          <template v-slot:activator="{ on }" >
                            <v-icon
                              
                              v-on="on"
                              small
                              class="mr-2"
                              @click="deletesoporte(item)"
                              >delete</v-icon
                            >
                          </template>
                          <span>Eliminar</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-icon
                              v-on="on"
                              small
                              class="mr-2"
                              @click="descargarsoporte(item)"
                              >mdi-file</v-icon
                            >
                          </template>
                          <span>Descargar</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-flex>
                  <v-flex xs12 sm12 v-show="!puedesolovisualizar()">
                    <v-row>
                      <v-col xs12 md10 sm10>
                        <template>
                          <v-file-input
                            accept=".pdf, .xlsx, .xls"
                            v-model="filesoporte"
                            show-size
                            multiple
                            label="cargar archivo"
                            @change="onsoportechange"
                          ></v-file-input>
                        </template>
                      </v-col>
                      <v-col xs12 md2 sm2>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              outlined
                              v-on="on"
                              class="ma-2"
                              @click="addsoporte"
                              tile
                              color="success"
                            >
                              <v-icon left>add</v-icon>Agregar
                            </v-btn>
                          </template>
                          <span>Agregar archivo</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                  </v-flex>
                </v-flex>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mx-1"
                    v-on="on"
                    color="blue darken-1"
                    @click="cerrarrollocal"
                  >
                    <div class="text-white">Cancelar</div>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip top v-if="!puedesolovisualizar()">
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mx-1"
                    v-on="on"
                    color="blue darken-1"
                    @click="preventguardar"
                  >
                    <div class="text-white">Guardar</div>
                  </v-btn>
                </template>
                <span>Guardar</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-layout>
    </div>

    <v-snackbar
      v-model="snack"
      :timeout="timeoutsnak"
      :color="MesaggeInfo.color"
    >
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      <v-btn text @click="functionalert">{{ buttontext }}</v-btn>
      <v-btn text v-show="snackalert" @click="cancelsave">Cancelar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "adminusuarios",
  data() {
    return {
      //Datos de las personas
      filearchivo: {},
      basearchivo: null,
      DataPersonas: [],
      currentRol: [],
      searchpersonas: "",
      Editedpersona: [],
      framepersona: false,
      Editarpersona: false,
      editedpersonaIndex: -1,
      headerpersonas: [
        { text: "Acciones", value: "action", sortable: false, width: "10px" },
        {
          text: "Nombre funcionario",
          value: "nombre",
          align: "left",
          width: "250px",
        },
        {
          text: "Estado",
          value: "estadoUsuario",
          align: "left",
          width: "120px",
        },
        {
          text: "Entidad",
          value: "identidadNavigation.nombre",
          align: "left",
          width: "350px",
        },
        {
          text: "Dependencia",
          value: "dependencia",
          align: "left",
          width: "250px",
        },
        { text: "Usuario", value: "correo", align: "left", width: "100px" },
        { text: "Teléfono", value: "telefono", align: "left", width: "200px" },
        { text: "Cargo", value: "cargo", align: "left", width: "200px" },
        {
          text: "Nombre Enlance",
          value: "nombreenlace",
          align: "left",
          width: "250px",
        },
        {
          text: "Correo Enlance",
          value: "correoenlace",
          align: "left",
          width: "200px",
        },
        {
          text: "Teléfono Enlance",
          value: "telefonoenlace",
          align: "left",
          width: "200px",
        },
      ],
      //Soportes
      tiposarchivo: null,
      soportes: [],
      deletesoportes: [],
      filesoporte: null,
      dialogSoportes: false,
      snackalert: false,
      headerFieldsSoportes: [
        {
          value: "nombrearchivo",
          text: "Nombre",
          sortable: true,
          width: "150px",
        },
        { text: "Acciones", value: "action", sortable: false, width: "10%" }
      ],
      //Fin Soportes
      exportable: {
        ID: "idpersona",
        Nombre: "nombre",
        Cargo: "cargo",
        Entidad: "identidadNavigation.nombre",
        Dependencia: "dependencia",
        Usuario: "correo",
        Teléfono: "telefono",
        Estado: "estadoUsuario",
        NombreEnlace: "nombreenlace",
        CorreoEnlace: "correoenlace",
        TelefonoEnlace: "telefonoenlace",
        Roles: "rolesConcat",
      },

      //datos del usuario
      SeletionRol: [],
      SeleccionPunto: [],
      EditedUsuario: [],

      //elementos del fomrulario
      buttonguardarestado: false,
      buttonfinalizarestado: false,
      loading: false,
      mostrarUsuarioPuntos: false,
      mostrarArchivoDelegado: false, 
      //campos del cuadro de dialog de mensajes
      snack: false,
      snackalert: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "cerrar",

      //Validacion de campos
      dictionary: {
        custom: {
          nombrefuncionario: {
            required: () => "El nombre del funcionario es un campo obligatorio",
            alpha_spaces: "Los valores ingresados",
            max: "está superando el límite de caracteres",
          },
          identificacion: {
            required: () =>
              "El numero de identificación es un campo obligatorio",
              max: "está superando el límite de caracteres",
          },
          entidad: {
            required: () =>
              "El campo Entidad es requerido,  seleccione una opción de la lista",
          },
          tipodocumento: {
            required: () =>
              "El campo Tipo de Documento es requerido,  seleccione una opción de la lista",
          },
          cargo: {
            required: () => "El campo cargo es requerido",
            max: "está superando el límite de caracteres",
          },
          dependencia: {
            max: "está superando el límite de caracteres",
          },
          telefono: {
            max: "está superando el límite de caracteres",
          },
          celular: {
            max: "está superando el límite de caracteres",
          },
          nombrejefe: {
            required: () => "El campo Nombre del superior es requerido",
            max: "está superando el límite de caracteres",
          },
          correojefe: {
            required: () => "El campo Correo del superior es requerido",
            email: () => "El correo electrónico es inválido",
            max: "está superando el límite de caracteres",
          },
          nombreenlace: {
            required: () => "El campo Nombre del enlace es requerido",
            max: "está superando el límite de caracteres",
          },
          correoenlace: {
            required: () => "El campo correo del enlace es requerido",
            email: () => "El correo electrónico del enlace es inválido",
            max: "está superando el límite de caracteres",
          },
          correoelectronico: {
            required: () => "El campo correo electronico es requerido",
            email: () => "El correo electrónico es inválido",
          },
          loginusuario: {
            required: () => "El campo usuario es requerido",
            email: () => "El correo electrónico es inválido",
          },
          rolusuario: {
            required: () =>
              "El rol es requerido, seleccione una o más opciones de la lista de roles",
          },
          revisioncomentario: {
            max: "esta superando el limite de caracteres",
          },
          puntousuario: {
            required: () => "El campo Punto es requerido",
          },
        },
      },
    };
  },
  methods: {
    ...mapActions([
      "get_listapersonausuario",
      "get_listapersonausuariobyid",
      "Getentidad",
      "get_roles",
      "PutPersona",
      "get_desbloquearusuario",
      "get_tipodocumentos",
      "get_puntos",
      "get_configuraciones"
    ]),
    ...mapActions("usuario/", ["get_usuarios", "get_usuarioedit"]),
    //Soportes
    deletesoporte(item) {
      const index = this.soportes.indexOf(item);
      if (confirm("Desea eliminar el soporte?")) {
        this.deletesoportes.push(item);
        this.soportes.splice(index, 1);
      }
    },
    descargarsoporte(item) {
      if (item.archivocompleto == null) {
        this.downloadsoporte({
          params: {
            idtabla: this.idtabla[0],
            idindicador: this.idregistro,
            idsoporte: item.idsoporte
          }
        });
      } else {
        const a = document.createElement("a");
        a.style.display = "none";
        document.body.appendChild(a);
        a.href = "data:"+ item.tipoarchivo + ";base64," + item.archivocompleto;
       
        a.setAttribute("download", item.nombrearchivo);
        a.click();
        window.URL.revokeObjectURL(a.href);
        document.body.removeChild(a);
      }
    },
    onsoportechange() {
      this.imageUrlsoporte = [];
      let error = false;
      if (this.filesoporte !== null) {
        for (let i = 0; i < this.filesoporte.length; i++) {
          if (error === false) {
            let file = this.filesoporte[i];
            let tipo = file.type.replace("application/", "");
            if (this.tiposarchivo.indexOf(tipo, 0) > 0) {
              if (file.size > this.tamanoarchivo * 1024000) {
                this.MesaggeInfo.mensajeRespuesta =
                  "El tamaño de uno de los archivos supera el límite de carga (" +
                  this.tamanoarchivo +
                  "Mb)";
                this.MesaggeInfo.color = "errorvue";
                this.snack = true;
                error = true;
              } else {
                let actual = this.soportes.filter(
                  p =>
                    p.nombrearchivo === file.name &&
                    (p.idversionado === this.selectedversionado)
                )[0];
                if (actual === undefined) {
                  let reader = new FileReader();
                  reader.onload = () => {
                    this.imageUrlsoporte.push(reader.result);
                  };
                  reader.readAsDataURL(file);
                } else {
                  this.MesaggeInfo.mensajeRespuesta =
                    "Uno de los archivos ya se encuentra relacionado en la versión";
                  this.MesaggeInfo.color = "errorvue";
                  this.snack = true;
                  error = true;
                }
              }
            } else {
              this.MesaggeInfo.mensajeRespuesta =
                "Uno de los archivos no es compatible con los tipos permitidos";
              this.MesaggeInfo.color = "errorvue";
              this.snack = true;
              error = true;
            }
          }
        }
        if (error === true) {
          this.imageUrlsoporte = [];
          this.filesoporte = [];
        }
      }
    },
    addsoporte() {
      if (this.filesoporte !== null) {
        for (let i = 0; i < this.filesoporte.length; i++) {
          let file = this.filesoporte[i];

          this.soporte = Object.assign({}, this.soportes);
          this.soporte.nombrearchivo = file.name,
          this.soporte.tipoarchivo = file.type,
          this.soporte.finalizado = false,
          this.soporte.archivocompleto = this.imageUrlsoporte[i],
          this.soporte.idsoporte = 0
          
          this.soportes.push(this.soporte);
        }
        this.imageUrlsoporte = [];
        this.filesoporte = [];
      } else {
        this.MesaggeInfo.mensajeRespuesta =
          "Seleccione un archivo para la carga";
        this.MesaggeInfo.color = "infovue";
        this.snack = true;
      }
    },
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "cerrar";
      this.timeoutsnak = 4000;
    },
    
    puedesolovisualizar(){
      return this.currentRol.findIndex(x => x == 3) !== -1;
    },
    getusuario() {
      if (localStorage.usuario !== undefined) {
        return JSON.parse(unescape(localStorage.usuario));
      } else {
        return null;
      }
    },
    SaveUser() {
      this.loading = true;
      let SendPersonaList = []
      SendPersonaList.push(this.Editedpersona)
      this.PutPersona({
        data: SendPersonaList,
      });
    },
    onchangeRol(e){
      if(e.filter(x => x == 3).length == 1)
       this.mostrarUsuarioPuntos = true;
      else
       this.mostrarUsuarioPuntos = false;

      if(e.filter(x => x == 2).length == 1)
      {
        
          this.mostrarArchivoDelegado = true;
      }
      else
      {
        this.filearchivo = {};
         this.basearchivo = null;
        this.mostrarArchivoDelegado = false;
      }
    },
    FinalizarRol() {},
    cancelsave() {
      this.snackalert = false;
      this.snack = false;
      this.buttontext = "cerrar";
      this.timeoutsnak = 4000;
    },
    preventguardar() {
      this.SeletionRol.forEach((element) => {
        ///uso esta linea para eliminar el primer elemento que viene en cero
        if (element == 0) {
          this.SeletionRol.shift();
        }
      });

      this.SeleccionPunto.forEach((element) => {
        ///uso esta linea para eliminar el primer elemento que viene en cero
        if (element == 0) {
          this.SeleccionPunto.shift();
        }
      });

      this.$validator.validateAll().then((result) => {
        if (!result) {
          ///este console lo vamos a dejar para ver los posibles error de validación
          console.log(this.$validator);
          this.snack = true;
          this.snackalert = false;
          this.buttontext = "cerrar";
          this.timeoutsnak = 4000;
          let Errores = "";
          this.$validator.errors.items.forEach((element) => {
            Errores = Errores + "( " + element.msg + " ), ";
          });
          this.MesaggeInfo.mensajeRespuesta =
            "la validación del formulario contiene errores " + Errores;
          this.MesaggeInfo.color = "infovue";
          return;
        } else {
          if (this.Editarpersona == false) {
            this.EditedUsuario.login = this.Editedpersona.correo;
          }
          this.Editarpersona = false;
          this.guardarrollocal();
        }
      });
    },
    guardarrollocal() {
      this.snackalert = false;
      this.Editedpersona.modificado = true;
      this.Editedpersona.soportes = this.soportes;

      if (this.EditedUsuario.login != "") {
        this.EditedUsuario.usuarioRol = [];
        this.SeletionRol.forEach((element) => {
          this.EditedUsuario.usuarioRol.push({
            idrol: element,
            idusuario: this.EditedUsuario.idusuario,
          });
        });

        this.EditedUsuario.usuarioPuntos = [];
        this.SeleccionPunto.forEach((element) => {
          this.EditedUsuario.usuarioPuntos.push({
            idpunto: element,
            idusuario: this.EditedUsuario.idusuario,
          });
        });

        this.Editedpersona.gestionarusuario = this.EditedUsuario;
        if (this.EditedUsuario.activo == null) {
          this.EditedUsuario.activo = false;
        }
      }
      if (this.editedpersonaIndex > -1) {
        Object.assign(
          this.DataPersonas[this.editedpersonaIndex],
          this.Editedpersona
        );
      } else {
        this.DataPersonas.push(this.Editedpersona);
      }
    console.log('this.Editedpersona', this.Editedpersona);
      this.editedpersonaIndex = -1;
      this.SaveUser();
      //this.framepersona = false;
    },
    cerrarrollocal() {
      this.framepersona = false;
      this.Editarpersona = false;

      this.Editedpersona = [];
      this.EditedUsuario = [];
    },
    gridedituser(item) {
      this.framepersona = true;
      this.Editarpersona = true;
      this.editedpersonaIndex = this.DataPersonas.indexOf(item);
      this.Editedpersona = Object.assign({}, item);
      this.get_listapersonausuariobyid({ params: { idpersona: this.Editedpersona.idpersona }})
    },
    newpersona() {
      this.filearchivo = {};
      this.basearchivo = null;
      this.editedpersonaIndex = -1;
      this.Editarpersona = false;
      this.framepersona = true;
      this.SeletionRol = [];
      this.SeletionRol.push(0);
      this.SeleccionPunto = [];
      this.SeleccionPunto.push(0);
      this.Editedpersona = {
        nombre: "",
        identificacion: "",
        identidad: "",
        cargo: "",
        correo: "",
        dependencia: "",
        telefono: "",
        celular: "",
        nombrejefe: "",
        correojefe: "",
        archivoCompleto: null
      };
      //this.Editedpersona = Object.assign({}, this.DataPersonas[1]);
      this.EditedUsuario = {
        idusuario: 0,
        login: "",
        idopcion: 0,
        activo: true,
      };
    },
    desbloquearusuario(item) {
      this.get_desbloquearusuario({
        params: {
          idusuario: item.idusuario,
        },
      });
    },
    functionalert() {
      if (this.buttontext == "cerrar") {
        this.snack = false;
      }
      if (this.buttontext == "aceptar") {
        this.snack = false;
        this.snackalert = false;
        this.timeoutsnak = 4000;
        this.buttontext == "cerrar";
        this.guardarrollocal();
      }
    },
  },
  created() {
    this.get_usuarios();
    this.get_listapersonausuario();
    this.get_tipodocumentos();
    this.Getentidad();
    this.get_roles();
    this.get_puntos();
    this.get_configuraciones();
    let user = this.getusuario();

    if (user != undefined)
      this.currentRol = user.usuarioRol.map((item) => {
        return item.idrol;
      });
  },
  $_veeValidate: {
    validator: "new",
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  computed: {
    ...mapGetters(["gpersonas", "gentidades", "groles", "gtipodocumentos","gconfiguraciones", "gpersonasbyid"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios", "gusuarioedit"]),
    ...mapGetters(["gpuntos"]),
  },

  watch: {
    gconfiguraciones() {
      this.tiposarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TiposArchivo"
      )[0].valor;
      this.tamanoarchivo = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoArchivo"
      )[0].valor;
      this.tamanopaquete = this.gconfiguraciones.filter(
        p => p.codigo === "TamanoPaquete"
      )[0].valor;
      let GetConfigtime = this.gconfiguraciones.filter(
        (X) => X.codigo == "TiempoEspera"
      )[0];
      if (GetConfigtime != undefined) {
        this.timewait = GetConfigtime.valor;
      }
    },
    gpersonas: function () {
      this.DataPersonas = this.gpersonas;
    },
    gpersonasbyid: function() {
      this.Editedpersona.soportes = this.gpersonasbyid.soportes
      this.soportes = this.Editedpersona.soportes;
    },
    Editedpersona: function () {
      if(this.Editedpersona.soportes!=undefined)
        this.soportes = this.Editedpersona.soportes;
      if (this.Editedpersona != null) {
        if (
          this.Editedpersona.gestionarusuario == null &&
          this.editedpersonaIndex > -1
        ) {
          this.SeletionRol = [];
          if (this.Editedpersona.idusuario != null) {
            this.get_usuarioedit({
              params: {
                idusuario: this.Editedpersona.idusuario,
              },
            });
          } else {
            this.EditedUsuario = {
              idusuario: 0,
              login: "",
              idopcion: 0,
              activo: true,
            };
          }
        } else {
          if (this.editedpersonaIndex > -1) {
            this.SeletionRol = [];
            this.Editedpersona.gestionarusuario.usuarioRol.forEach(
              (element) => {
                this.SeletionRol.push(element.idrol);
              }
            );
            this.SeleccionPunto = [];
            this.Editedpersona.gestionarusuario.usuarioPuntos.forEach(
              (element) => {
                this.SeleccionPunto.push(element.idpunto);
              }
            );
          }
        }
        if(this.Editedpersona.archivoCompleto != null)
        {
            this.basearchivo = this.Editedpersona.archivoCompleto;
            this.mostrarArchivoDelegado = true;
        }
        else
        {
          this.filearchivo = {};
          this.basearchivo = null;
          if(this.SeletionRol.findIndex(x => x == 2) == -1)
            this.mostrarArchivoDelegado = false;
        }
          
      }
    },
    gusuarioedit: function () {
      this.mostrarUsuarioPuntos = false;
      this.mostrarArchivoDelegado = false;
      this.EditedUsuario = this.gusuarioedit;
      this.SeletionRol = [];
      if (this.gusuarioedit.usuarioRol != null) {
        
        this.gusuarioedit.usuarioRol.forEach((element) => {
          this.SeletionRol.push(element.idrol);
          if(element.idrol == 3)
            this.mostrarUsuarioPuntos = true;
          if(element.idrol == 2)
            this.mostrarArchivoDelegado = true;
          
        });
      }
      if (this.gusuarioedit.usuarioPuntos != null) {
        this.SeleccionPunto = [];
        this.gusuarioedit.usuarioPuntos.forEach((element) => {
          this.SeleccionPunto.push(element.idpunto);
        });
      }
    },
    ginformation() {
      if (this.loading) {
        if (this.ginformation.idGenerado == 1) {
          this.SeletionRol = [];
          this.SeleccionPunto = [];
          this.Editedpersona = [];
          this.framepersona = false;
        }
        this.MesaggeInfo = this.ginformation;
        this.snack = true;
        //este console por favor dejarlo, es para que el usuario tenga en consola los posibles mensajes por si no alcanza a leerlo
        console.log(this.MesaggeInfo.mensajeRespuesta);
        this.loading = false;
        this.DataPersonas = [];
        setTimeout(() => {
          this.get_listapersonausuario();
        }, 1000);
      }
    },
  },
};
</script>